<template id="appAdminFeatureToggles">
  <div id="editPage">
    <div id="featureTogglePage" class="column">
      <div>Feature Toggles</div>
      <div id="featureToggleList" class="fullHeight">
        <md-table>
          <md-table-row>
            <md-table-head>Id</md-table-head>
            <md-table-head
              >Type
              <span class="info-icon" @click="showFeatureTypeInfo = true">
                i
              </span></md-table-head
            >
          </md-table-row>
          <md-table-row
            v-for="featureToggle in featureToggles"
            :key="featureToggle.id"
            :class="{
              'md-raised': selectedToggleId === featureToggle.id,
              isAllowedForSelectedAdUser:
                isToggleAllowedForSelectedAdUser(featureToggle),
            }"
            @click="selectedToggleId = featureToggle.id"
          >
            <md-table-cell>{{ featureToggle.id }}</md-table-cell>
            <md-table-cell>
              <multiselect
                v-model="featureToggle.metadata.featureType"
                :allow-empty="false"
                class="dropDown"
                deselect-label=""
                :options="
                  featureTypes
                    .filter((ft) => ft.label != 'Any')
                    .map((ft) => ft.value)
                "
                :searchable="false"
                select-label=""
                selected-label=""
                @input="onFeatureTypeChanged(featureToggle)"
              ></multiselect
            ></md-table-cell>
            <md-table-cell
              ><div
                class="fa fa-trash"
                @click="showDeleteToggleDialog = true"
              ></div
            ></md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div>
        <md-button
          class="md-primary md-raised"
          @click="showCreateFeatureToggle = true"
        >
          Add Feature Toggle
        </md-button>
        <md-button class="md-primary md-raised" @click="downloadCsvFile()">
          Download CSV
        </md-button>
      </div>
    </div>
    <div class="column">
      <div v-if="selectedToggleId">
        <div>Drag Groups Below</div>
        <md-table class="dragArea">
          <draggable
            v-model="toggleGroups"
            draggable=".nothing"
            :group="{ name: 'groups', pull: false }"
            @add="linkToggleAndGroup"
          >
            <md-table-row v-for="group in toggleGroups" :key="group.id">
              <md-table-cell>{{ group.displayName }}</md-table-cell>
              <md-table-cell
                ><div class="row">
                  <div
                    class="fa fa-trash"
                    @click="unlinkToggleAndGroup(group.id)"
                  ></div>
                  <md-button
                    class="md-primary md-raised smallButton"
                    @click="showGroupUsers(group)"
                    >Users</md-button
                  >
                </div></md-table-cell
              >
            </md-table-row>
          </draggable>
        </md-table>
        <div>Drag Users Below</div>
        <md-table class="dragArea">
          <draggable
            v-model="toggleUsers"
            draggable=".nothing"
            :group="{ name: 'users', pull: false }"
            @add="linkToggleAndUser"
          >
            <md-table-row v-for="user in toggleUsers" :key="user.id">
              <md-table-cell>{{ user.displayName }}</md-table-cell>
              <md-table-cell
                ><div class="row">
                  <div
                    class="fa fa-trash"
                    @click="unlinkToggleAndUser(user.id)"
                  ></div>
                  <md-button
                    class="md-primary md-raised smallButton"
                    @click="showUserGroups(user)"
                    >Groups</md-button
                  >
                </div></md-table-cell
              >
            </md-table-row>
          </draggable>
        </md-table>
      </div>
      <div v-else>Select a feature toggle to Activate</div>
    </div>
    <div class="column">
      <div>Azure AD User Groups</div>
      <div class="adRow">
        <input
          id="searchInput"
          v-model="adGroupFilter"
          class="search-input"
          :placeholder="adGroupFilterFocus ? '' : 'Type at least 2 characters'"
          type="text"
          @blur="adGroupFilterFocus = false"
          @focus="adGroupFilterFocus = true"
        />
      </div>
      <div v-if="adGroupFilter.length >= 2">
        <div v-if="filteredAdGroups.length > 30">
          Too many results, specify more precise filter
        </div>
        <div v-else-if="filteredAdGroups.length === 0">No groups found</div>
        <div v-else id="groupList">
          <md-table>
            <draggable
              v-model="filteredAdGroups"
              :group="{ name: 'groups', pull: 'clone' }"
              :move="checkMoveGroup"
            >
              <md-table-row
                v-for="group in filteredAdGroups"
                :key="group.id"
                :class="{
                  'md-raised': selectedGroup === group,
                  linkedToSelectedFeature: groupLinkedToSelectedFeature(group),
                }"
                @click="selectedGroup = group"
              >
                <md-table-cell
                  ><div class="row">
                    {{ group.displayName }}
                    <md-button
                      class="md-primary md-raised smallButton"
                      @click="showGroupUsers(group)"
                      >Users</md-button
                    >
                  </div></md-table-cell
                >
              </md-table-row>
            </draggable>
          </md-table>
        </div>
      </div>
    </div>
    <div class="column">
      <div>Azure AD Users</div>
      <div class="adRow">
        <input
          id="searchInput"
          v-model="localAdUserFilter"
          class="search-input"
          :placeholder="
            adUserFilterFocus ? '' : 'Type at least first 2 characters'
          "
          type="text"
          @blur="adUserFilterFocus = false"
          @focus="adUserFilterFocus = true"
        />
      </div>
      <div v-if="adUserFilter.length >= 2">
        <div v-if="filteredAdUsers.length > 30">
          Too many results, specify more precise filter
        </div>
        <div v-else-if="filteredAdUsers.length === 0">No users found</div>
        <div v-else id="userList">
          <md-table>
            <draggable
              v-model="filteredAdUsers"
              :group="{ name: 'users', pull: 'clone' }"
              :move="checkMoveUser"
            >
              <md-table-row
                v-for="user in filteredAdUsers"
                :key="user.id"
                :class="{
                  'md-raised': selectedUser === user,
                  linkedToSelectedFeature: userLinkedToSelectedFeature(user),
                }"
                @click="selectedUser = user"
              >
                <md-table-cell
                  ><div class="row">
                    {{ user.displayName }}
                    <md-button
                      class="md-primary md-raised smallButton"
                      @click="showUserGroups(user)"
                      >Groups</md-button
                    >
                  </div>
                </md-table-cell>
              </md-table-row>
            </draggable>
          </md-table>
        </div>
      </div>
    </div>
    <md-dialog :md-active.sync="showCreateFeatureToggle">
      <md-dialog-title>Create Feature Toggle</md-dialog-title>
      <md-dialog-content id="createFeatureToggle">
        <div class="inputRow">
          <div>Feature Type</div>
          <multiselect
            v-model="featureToggleType"
            :allow-empty="false"
            class="dropDown"
            deselect-label=""
            label="label"
            :options="featureTypes"
            :preselect-first="true"
            :searchable="false"
            select-label=""
            selected-label=""
          ></multiselect>
        </div>
        <div class="inputRow">
          <div>Id</div>
          <md-field style="padding: 0px; margin: 0px">
            <md-input v-model="featureToggleId" style="width: 80px"
          /></md-field>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary md-raised"
          :disabled="!isValidToggleInput"
          @click="createFeatureToggle()"
          >Create</md-button
        >
        <md-button class="md-primary" @click="showCreateFeatureToggle = false"
          >Cancel</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDeleteToggleDialog">
      <md-dialog-title>Delete Feature Toggle</md-dialog-title>
      <md-dialog-content id="deleteFeatureToggleDialog">
        <div>
          Are you sure you want to delete feature toggle '{{
            selectedToggleId
          }}'?
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary md-raised"
          @click="deleteFeatureToggle(selectedToggleId)"
          >Delete</md-button
        >
        <md-button class="md-primary" @click="showDeleteToggleDialog = false"
          >Cancel</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showUsersOrGroups">
      <md-dialog-title>{{ usersOrGroupsTitle }}</md-dialog-title>
      <md-dialog-content id="showUsersOrGroups">
        <div v-for="userOrGroup in usersOrGroups" :key="userOrGroup.id">
          {{ userOrGroup.displayName }}
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showUsersOrGroups = false"
          >Ok</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showFeatureTypeInfo">
      <md-dialog-title>Feature Types</md-dialog-title>
      <md-dialog-content
        id="createFeatureToggle"
        style="width: 800px; height: 400px"
      >
        <md-table>
          <md-table-row>
            <md-table-head>Feature Type</md-table-head>
            <md-table-head>Description</md-table-head>
            <md-table-head>Example</md-table-head>
          </md-table-row>
          <md-table-row>
            <md-table-cell>Administrative</md-table-cell
            ><md-table-cell>Technical administration</md-table-cell
            ><md-table-cell>register_generators</md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell>Experimental</md-table-cell
            ><md-table-cell>Non-validated code for prototyping</md-table-cell
            ><md-table-cell>ai_landmark_placement</md-table-cell> </md-table-row
          ><md-table-row>
            <md-table-cell>Beta</md-table-cell
            ><md-table-cell
              >Tested but non-validated code to be tested for clinical
              research</md-table-cell
            ><md-table-cell>looking_glass</md-table-cell> </md-table-row
          ><md-table-row>
            <md-table-cell>License</md-table-cell
            ><md-table-cell>Validated but licensed code</md-table-cell
            ><md-table-cell>CTncSF_segmentation</md-table-cell> </md-table-row
          ><md-table-row>
            <md-table-cell>Permission</md-table-cell
            ><md-table-cell>Validated code, based on role</md-table-cell
            ><md-table-cell>audit_reader</md-table-cell>
          </md-table-row></md-table
        >
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showFeatureTypeInfo = false"
          >Ok</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import appSettings from "./appSettings";
import { mapActions, mapMutations, mapState } from "vuex";
import multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import downloadFile from "./downloadFile";
import moment from "moment";

export default {
  name: "AppAdminFeatures",
  components: {
    multiselect,
    draggable,
  },
  data: () => ({
    showDeleteToggleDialog: false,
    showCreateFeatureToggle: false,
    showUsersOrGroups: false,
    showFeatureTypeInfo: false,
    usersOrGroups: [],
    usersOrGroupsTitle: "",

    selectedToggleId: null,
    featureToggles: [],
    featureToggleId: "",
    featureToggleDisplayName: "",
    featureToggleType: { value: "Any", label: "(Select Type)" },

    toggleGroups: [],
    toggleUsers: [],

    selectedAdUser: null,
    adUserFilterFocus: false,
    adUserFilter: "",
    adUsers: [],
    selectedUser: null,
    users: [],
    timeout: null,

    selectedAdGroup: null,
    adGroupFilterFocus: false,
    adGroupFilter: "",
    adGroups: [],
    selectedGroup: null,
    filteredAdGroups: [],
    groups: [],

    selectedUserForEdit: null,
    selectedGroupForEdit: null,
    selectedFeatureTypesForEdit: [],
    featureTypeValues: [
      "Experimental",
      "Beta",
      "Administrative",
      "License",
      "Permission",
    ],

    adUserFeatures: [],

    featureTypes: [
      { label: "Any", value: "(Select Type)" },
      { label: "Experimental", value: "Experimental" },
      { label: "Beta", value: "Beta" },
      { label: "Administrative", value: "Administrative" },
      { label: "License", value: "License" },
      { label: "Permission", value: "Permission" },
    ],
  }),
  computed: {
    ...mapState(["idToken"]),
    localAdUserFilter: {
      set(filter) {
        // debounce
        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.adUserFilter = filter;
        }, 400);
      },
      get() {
        return this.adUserFilter;
      },
    },
    isValidToggleInput() {
      return this.featureToggleId && this.featureToggleType.value !== "Any";
    },
    filterTypesDisplayName() {
      return this.selectedUserForEdit
        ? `'User '${this.selectedUserForEdit.displayName}'`
        : this.selectedGroupForEdit
        ? `'Group '${this.selectedGroupForEdit.displayName}'`
        : "";
    },
    filteredAdUsers() {
      return this.adUsers.filter((u) =>
        u.displayName.toLowerCase().includes(this.adUserFilter.toLowerCase())
      );
    },
  },
  watch: {
    selectedToggleId(toggleId) {
      this.updateLinkedUsersAndGroups(toggleId);
    },
    featureToggles() {
      this.updateLinkedUsersAndGroups(this.selectedToggleId);
    },
    selectedAdUser() {
      this.showTogglesOfAdUser();
    },
    adGroupFilter(filter) {
      this.filterAdGroups(filter);
    },
    adUserFilter(filter) {
      if (filter.length < 2) return;
      this.loadAdUsers(filter);
    },
  },
  async created() {
    await this.loadAll();
  },
  methods: {
    ...mapActions(["fetchAzure", "postAzure", "putAzure", "deleteAzure"]),
    ...mapMutations(["setErrorMessage"]),
    async downloadCsvFile() {
      const url = `${appSettings.remoteurl}/api/featureToggles/csv`;
      const formattedDateTime = moment(new Date()).format("YYYY-MM-DD_HH:mm");
      await downloadFile(url, `toggles_${formattedDateTime}.csv`, this.idToken);
    },
    async showUserGroups(user) {
      const url = `${appSettings.remoteurl}/api/ad/users/${user.id}/groups`;
      this.usersOrGroups = await this.fetchAzure(url);
      this.usersOrGroupsTitle = `Groups for ${user.displayName}`;
      this.showUsersOrGroups = true;
    },
    async showGroupUsers(group) {
      const url = `${appSettings.remoteurl}/api/ad/groups/${group.id}/users`;
      this.usersOrGroups = await this.fetchAzure(url);
      this.usersOrGroupsTitle = `Users in ${group.displayName}`;
      this.showUsersOrGroups = true;
    },
    filterAdGroups(filter) {
      this.filteredAdGroups = this.adGroups.filter((g) =>
        g.displayName.toLowerCase().includes(filter.toLowerCase())
      );
    },
    async onFeatureTypeChanged(featureToggle) {
      const url = `${appSettings.remoteurl}/api/featureToggles/${featureToggle.id}`;
      await this.putAzure({
        url,
        metadata: { featureType: featureToggle.metadata.featureType },
      });
    },
    setUserFilterImmediately(filter) {
      clearTimeout(this.timeout);
      this.setFilter(filter);
    },
    updateLinkedUsersAndGroups(toggleId) {
      this.toggleGroups = [];
      this.toggleUsers = [];
      if (!toggleId) return;

      let foundToggle = this.featureToggles.find((t) => t.id === toggleId);
      if (!foundToggle) {
        this.selectedToggleId = null;
      } else {
        this.toggleGroups = foundToggle.groups;
        this.toggleUsers = foundToggle.users;
      }
    },
    async loadFeatureToggles() {
      let url = `${appSettings.remoteurl}/api/featureToggles`;
      this.featureToggles = await this.fetchAzure(url);
    },
    isToggleAllowedForSelectedAdUser(featureToggle) {
      return this.adUserFeatures
        .map((toggle) => toggle.id)
        .includes(featureToggle.id);
    },
    groupLinkedToSelectedFeature(group) {
      return this.toggleGroups.map((x) => x.id).includes(group.id);
    },
    userLinkedToSelectedFeature(user) {
      return this.toggleUsers.map((x) => x.id).includes(user.id);
    },
    checkMoveGroup(evt) {
      return !this.toggleGroups.some(
        (elem) => elem.id === evt.draggedContext.element.id
      );
    },
    async linkToggleAndGroup(evt) {
      let groupId = this.filteredAdGroups[evt.oldIndex].id;
      let url = `${appSettings.remoteurl}/api/featureToggles/${this.selectedToggleId}/groups/${groupId}`;
      await this.putAzure({
        url,
        metadata: {},
      });
      await this.loadFeatureToggles();
    },
    async unlinkToggleAndGroup(groupId) {
      let url = `${appSettings.remoteurl}/api/featureToggles/${this.selectedToggleId}/groups/${groupId}`;
      await this.deleteAzure({ url });
      await this.loadFeatureToggles();
    },
    checkMoveUser(evt) {
      return !this.toggleUsers.some(
        (elem) => elem.id === evt.draggedContext.element.id
      );
    },
    async linkToggleAndUser(evt) {
      let userId = this.filteredAdUsers[evt.oldIndex].id;
      let url = `${appSettings.remoteurl}/api/featureToggles/${this.selectedToggleId}/users/${userId}`;
      await this.putAzure({
        url,
        metadata: {},
      });
      await this.loadFeatureToggles();
    },
    async unlinkToggleAndUser(userId) {
      let url = `${appSettings.remoteurl}/api/featureToggles/${this.selectedToggleId}/users/${userId}`;
      await this.deleteAzure({ url });
      await this.loadFeatureToggles();
    },
    async createFeatureToggle() {
      const url = `${appSettings.remoteurl}/api/featureToggles/${this.featureToggleId}`;
      await this.postAzure({
        url,
        metadata: {
          displayName: this.featureToggleId,
          featureType: this.featureToggleType.value,
        },
      });
      await this.loadFeatureToggles();
      this.showCreateFeatureToggle = false;
    },
    async deleteFeatureToggle(id) {
      const url = `${appSettings.remoteurl}/api/featureToggles/${id}`;
      await this.deleteAzure({ url });
      this.showDeleteToggleDialog = false;
      await this.loadFeatureToggles();
    },
    async loadAll() {
      await this.loadFeatureToggles();
      await this.loadUsers();
      await this.loadGroups();
      await this.loadAdGroups();
      this.filterAdGroups("");
    },
    async loadUsers() {
      let url = `${appSettings.remoteurl}/api/featureToggles/users`;
      this.users = await this.fetchAzure(url);
    },
    async loadAdUsers(prefix) {
      if (prefix.length < 2) return;
      let url = `${appSettings.remoteurl}/api/ad/users/${prefix}`;
      this.adUsers = await this.fetchAzure(url);
    },
    async loadGroups() {
      let url = `${appSettings.remoteurl}/api/featureToggles/groups`;
      this.groups = await this.fetchAzure(url);
    },
    async loadAdGroups() {
      let url = `${appSettings.remoteurl}/api/ad/groups`;
      this.adGroups = await this.fetchAzure(url);
    },
    async createUser() {
      const url = `${appSettings.remoteurl}/api/featureToggles/users/${this.selectedAdUser.id}`;
      let metadata = {};

      await this.postAzure({
        url,
        metadata,
      });
      await this.loadUsers();
    },
    async showTogglesOfAdUser() {
      this.adUserFeatures = [];
      if (!this.selectedAdUser) return;

      const url = `${appSettings.remoteurl}/api/allowedToggles/${this.selectedAdUser.id}`;
      this.adUserFeatures = await this.fetchAzure(url);
    },
    async createGroup() {
      const url = `${appSettings.remoteurl}/api/featureToggles/groups/${this.selectedAdGroup.id}`;
      let metadata = {};

      await this.postAzure({
        url,
        metadata,
      });
      await this.loadGroups();
    },
  },
};
</script>
<style scoped>
.smallButton {
  height: 20px;
}
.search-input {
  padding: 10px;
  margin: 5px;
  border: 0px;
  flex: 1;
  width: 100%;
  height: 80;
  font-size: large;
  background-color: #3d8094;
  border-radius: 8px;
}
.search-input::placeholder {
  color: silver;
}
.search-input:focus {
  color: white;
  outline: none;
}
.adRow {
  display: flex;
  flex-direction: row;
}
#editPage {
  display: flex;
  flex-direction: row;
}
#featureTogglePage {
  display: flex;
  flex-direction: column;
}
#createFeatureToggle {
  width: 400px;
  height: 300px;
  flex-direction: column;
  align-content: top;
}
#showUsersOrGroups {
  flex-direction: column;
  align-content: top;
  height: 100%;
  justify-content: flex-start;
}
.md-field .md-input {
  background-color: #3d8094;
  margin-top: 4px;
  border-radius: 8px;
}
.md-field .label {
  margin: 10px;
}
.md-table-row.md-raised {
  background-color: #5daec7;
}
.dragArea {
  background-color: silver;
  padding: 2px;
  min-height: 30px;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.column {
  margin: 3px;
}
.inputRow {
  display: flex;
  flex-direction: row;
  width: 300px;
}
.isAllowedForSelectedAdUser {
  border-color: yellow;
  border-style: inset;
}
.linkedToSelectedFeature {
  border-color: green;
  border-style: inset;
}
.fa-edit {
  margin-right: 4px;
}

::v-deep .multiselect__tags {
  background-color: #398ca5;
}

.fullHeight {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}

.dropDown {
  max-height: 10px;
}
::v-deep .multiselect__single {
  font-size: 13px;
}
.info-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  background-color: var(--accent-color-dark);
  color: white;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  margin-left: 4px;
}
.md-table-cell {
  text-align: left;
}
</style>
